'use client'

import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'

interface SearchContext {
  query: string
  setQuery: Dispatch<SetStateAction<string>>
}

const SearchContext = createContext<SearchContext>({
  query: '',
  setQuery: () => '',
})

export const SearchContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [query, setQuery] = useState('')

  return <SearchContext.Provider value={{ query, setQuery }}>{children}</SearchContext.Provider>
}

export const useSearchContext = () => useContext(SearchContext)
